var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMsTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 46,
    height: 46,
    rx: 23,
    fill: "#4B53BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2861 21.2546V28.1075C19.2861 28.9441 19.4913 29.7315 19.8479 30.4289H24.4898C25.1473 30.4289 25.7861 29.7668 25.7861 29.1716V20.2341L25.5252 20.2146H20.3261C19.7513 20.2146 19.2861 20.6798 19.2861 21.2546",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7019 17.4287H21.9385C22.334 18.6711 23.4836 19.5765 24.857 19.5765C25.1829 19.5765 25.4903 19.5124 25.7855 19.4186V18.5124C25.7855 17.9162 25.298 17.4287 24.7019 17.4287",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0958 20.2146H28.4595L27.165 21.2611V26.4509C27.165 28.3777 28.7269 29.9395 30.6537 29.9395C32.5805 29.9395 34.1423 28.3777 34.1423 26.4509V21.2611C34.1423 20.6835 33.6734 20.2146 33.0958 20.2146",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2141 16.9645C33.2141 18.2469 32.1751 19.2859 30.8927 19.2859C29.6104 19.2859 28.5713 18.2469 28.5713 16.9645C28.5713 15.6821 29.6104 14.6431 30.8927 14.6431C32.1751 14.6431 33.2141 15.6821 33.2141 16.9645",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3261 20.2146H28.4604C29.0352 20.2146 29.5004 20.6798 29.5004 21.2546V28.1075C29.5004 30.9285 27.2143 33.2146 24.3933 33.2146C21.5723 33.2146 19.2861 30.9285 19.2861 28.1075V21.2546C19.2861 20.6798 19.7513 20.2146 20.3261 20.2146",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3261 20.2146H28.4604C29.0352 20.2146 29.5004 20.6798 29.5004 21.2546V28.1075C29.5004 30.9285 27.2143 33.2146 24.3933 33.2146C21.5723 33.2146 19.2861 30.9285 19.2861 28.1075V21.2546C19.2861 20.6798 19.7513 20.2146 20.3261 20.2146",
    stroke: "#4B53BC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9339 16.5002C27.9339 18.1995 26.5568 19.5765 24.8576 19.5765C23.1583 19.5765 21.7803 18.1995 21.7803 16.5002C21.7803 14.8009 23.1583 13.4238 24.8576 13.4238C26.5568 13.4238 27.9339 14.8009 27.9339 16.5002",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7738 29.5002H12.9401C12.3449 29.5002 11.8574 29.0127 11.8574 28.4166V17.5839C11.8574 16.9877 12.3449 16.5002 12.9401 16.5002H23.7738C24.3699 16.5002 24.8574 16.9877 24.8574 17.5839V28.4166C24.8574 29.0127 24.3699 29.5002 23.7738 29.5002",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7738 29.5002H12.9401C12.3449 29.5002 11.8574 29.0127 11.8574 28.4166V17.5839C11.8574 16.9877 12.3449 16.5002 12.9401 16.5002H23.7738C24.3699 16.5002 24.8574 16.9877 24.8574 17.5839V28.4166C24.8574 29.0127 24.3699 29.5002 23.7738 29.5002",
    stroke: "#4B53BC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3109 20.7509H19.0926V26.7142H17.6347V20.7509H15.4043V19.2856H21.3109V20.7509Z",
    fill: "#4B53BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsTeams);
export default __webpack_public_path__ + "static/media/MS-Teams.bf2c71fc8a80599038150cf8e5be3c86.svg";
export { ForwardRef as ReactComponent };